"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var theme = exports.theme = {};
//# sourceMappingURL=theme.js.map



// WEBPACK FOOTER //
// ../documittu/packages/template/dist/theme.js